__turbopack_context__.v({
  "editorialSection": "n_FgBa_editorialSection",
  "imageItem": "n_FgBa_imageItem",
  "imageWrapper": "n_FgBa_imageWrapper",
  "imageWrapperPortrait": "n_FgBa_imageWrapperPortrait",
  "images": "n_FgBa_images",
  "textHeader": "n_FgBa_textHeader",
});
